import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider, ProtectedRoute } from "@/context/AdminAuth";
import LandingPage from "@/pages/LandingPage";
import LandingLite from "@/pages/LandingLite";
import CartePage from "@/pages/CartePage";
import LieuPage from "@/pages/LieuPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Presse from "@/pages/Presse";
import EspaceBeneficiaire from "@/pages/EspaceBeneficiaire";
import RecevoirBon from "@/pages/RecevoirBon";
import OffrirTpoz from "@/pages/OffrirTpoz";
import DemandeCode from "@/pages/DemandeCode";
import ExperiencesPage from "@/pages/ExperiencesPage";
import { useParams } from "react-router-dom";
import MentionsLegales from "@/pages/MentionsLegales";
import ConditionsPage from "@/pages/ConditionsPage";
import PartenaireVerif from "@/pages/PartenaireVerif";

function ExperienceRedirect() {
  const { id } = useParams();
  return <Navigate to={`/tpoz?exp=${id}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<LandingLite />} />
            <Route path="/lite" element={<Navigate to="/" replace />} />
            <Route path="/carte" element={<CartePage />} />
            <Route path="/lieu/:id" element={<LieuPage />} />
            <Route path="/site" element={<LandingPage />} />
            <Route path="/presse" element={<Presse />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/conditions" element={<ConditionsPage />} />
            <Route path="/espace" element={<EspaceBeneficiaire />} />
            <Route path="/recevoir-mon-bon" element={<RecevoirBon />} />
            <Route path="/offrir" element={<OffrirTpoz />} />
            <Route path="/demande" element={<DemandeCode />} />
            <Route path="/tpoz" element={<ExperiencesPage />} />
            <Route path="/partenaire" element={<PartenaireVerif />} />
            <Route path="/experience/:id" element={<ExperienceRedirect />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
